import { Box, Paper, Stack, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import purple from '../../assets/accountstransfers/purple.png';
import beige from '../../assets/accountstransfers/beige.png';
import purpledark from '../../assets/accountstransfers/purple-dark.png';

const AccountsNTransfers = () => {

    const featureData = {
        accountAndTransfers: [
            {
                title: "REGISTRATION",
                description: "REGISTER FOR AN EPAYR ACCOUNT",
                price: "FREE",
            },
            {
                title: "MONTHLY FEE",
                description: "MONTHLY MAINTENANCE FEE",
                price: "1 EUR",
            },
            {
                title: "INCOMING TRANSFERS",
                description: "INCOMING TRANSFERS TO YOUR EPAYR ACCOUNT",
                price: "FREE",
            },
            {
                title: "INSTANT TRANSFERS",
                description: "INSTANT TRANSFERS BETWEEN EPAYR USERS",
                price: "FREE",
            },
        ],
        outgoingTransfers: [
            {
                title: "SEPA TRANSFERS",
                description: "REGISTER FOR AN EPAYR ACCOUNT",
                price: "1 EUR",
            },
            {
                title: "SWIFT TRANSFERS",
                description: "MONTHLY MAINTENANCE FEE",
                price: "1.5%",
                subtext: "MIN. 5 EUR",
            },
        ],
        currencyExchange: [
            {
                title: "COMPETITIVE RATES",
                description: "REGISTER FOR AN EPAYR ACCOUNT",
                price: "0.35%",
                uppertext: "STARTING FROM"
            },
        ]
    };

    const FeatureCard = ({ title, description, price, subtext, uppertext }: { title: string, description: string, price: string, subtext?: string, uppertext?: string }) => {
        return (
            <Paper
                elevation={0}
                sx={{
                    display: "flex",
                    borderRadius: "12px",
                    flex: "1 0 0",
                    alignItems: { sm: "center", xs: "flex-start" },
                    alignSelf: "stretch",
                    bgcolor: "grey.100",
                    height: "100%"
                }}
            >
                <Box sx={{ flex: 1, gap: "32px", padding: {md: "54px 48px", xs: "24px 20px"}, display: "flex", alignItems: "center", alignSelf: "stretch" }}>
                    <Stack spacing={2}>
                        <Typography variant="subtitle14" sx={{ color: "darkPurple.500" }}>
                            {title}
                        </Typography>
                        <Typography variant="body5" sx={{ color: "gray.400" }}>
                            {description}
                        </Typography>
                    </Stack>
                </Box>
                <Box
                    sx={{
                        // width: { sm: 166, xs: 85 },
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: {
                            // sm: "54px 48px",
                            xs: "24px 20px 24px 4px",
                        },
                        bgcolor: "grey.100",
                        // gap: "32px"
                    }}
                >
                    {uppertext && (
                        <Typography variant="body4" sx={{ color: "gray.400", textAlign: "center", mb: 1 }}>
                            {uppertext}
                        </Typography>
                    )}
                    <Box
                        sx={{
                            width: { sm: "100px", xs: "75px" },
                            height: {sm: "50px", xs: "40px"},
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            bgcolor: "#E9FF5C",
                            borderRadius: "10px",
                        }}
                    >
                        <Typography fontSize={{ sm: 20, xs: 18 }} sx={{ color: "lime.300", fontWeight: 600 }}>
                            {price}
                        </Typography>
                    </Box>
                    {subtext && (
                        <Typography variant="body4" sx={{ color: "gray.400", mt: 1 }}>
                            {subtext}
                        </Typography>
                    )}
                </Box>
            </Paper>
        );
    };

    const SectionTitle = ({ coloredText, plainText }: { coloredText: string; plainText: string }) => (
        <Typography
            display="flex"
            alignItems="flex-start"
            alignSelf="stretch"
            fontSize={{ sm: 36, xs: 28 }}
            textTransform="uppercase"
            lineHeight={1.2}
            fontWeight={500}
            fontStyle="normal"
            fontFamily="Manrope"
        >
            <Box component="span" sx={{ color: "#9484BA" }}>
                {coloredText}
            </Box>
            <Box component="span" sx={{ width: "8px" }} />
            <Box component="span" sx={{ color: "#321338" }}>
                {plainText}
            </Box>
        </Typography>
    );

    const ChartBox = ({ chartType }: { chartType: string }) => (
        <Paper
            elevation={0}
            sx={{
                flex: 1,
                borderRadius: "12px",
                display: "flex",
                position: "relative",
                height: "100%",
                overflow: "hidden",
            }}
        >
            {chartType === "purple" && (
                <Box
                    sx={{
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                    <Box component="img" sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                        src={purple} alt="chart" />
                </Box>
            )}
            {chartType === "beige" && (
                <Box
                    sx={{
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                    <Box component="img" sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }} src={beige} alt="chart" />
                </Box>
            )}
            {chartType === "purple-dark" && (
                <Box
                    sx={{
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                    <Box component="img" sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }} src={purpledark} alt="chart" />
                </Box>
            )}
        </Paper>
    );


    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start" gap="80px" maxWidth={1320} width={"100%"} margin="0 auto" padding="0 20px">
            <Box gap="32px" display="flex" flexDirection="column" alignItems="flex-start" width={"100%"}>
                <SectionTitle coloredText="Account" plainText=" & Transfers" />
                <Stack spacing={2.5}>
                    <Grid container spacing={2.5}>
                        {featureData.accountAndTransfers.map((feature, index) => (
                            <Grid size={{ xs: 12, sm: 12, md: 6 }} key={index}>
                                <FeatureCard {...feature} />
                            </Grid>
                        ))}
                    </Grid>
                </Stack>
            </Box>
            <Box gap="32px" display="flex" flexDirection="column" alignItems="flex-start" width={"100%"}>
                <SectionTitle coloredText="Outgoing" plainText=" Transfers" />
                <Stack spacing={2.5}>
                    <Grid container spacing={2.5}>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{
                            order: {md: 1, xs: 1}
                        }}>
                            <FeatureCard {...featureData.outgoingTransfers[0]} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{
                            order: {md: 2, xs: 2}
                        }}>
                            <ChartBox chartType="purple" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{
                            order: {md: 3, xs: 4}
                        }}>
                            <ChartBox chartType="beige" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{
                            order: {md: 4, xs: 3}
                        }}>
                            <FeatureCard {...featureData.outgoingTransfers[1]} />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>

            <Box gap="32px" display="flex" flexDirection="column" alignItems="flex-start" width={"100%"}>
                <SectionTitle coloredText="Currency " plainText="Exchange" />
                <Stack spacing={2.5} width={"100%"}>
                    <Grid container spacing={2.5} width={"100%"}>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <FeatureCard {...featureData.currencyExchange[0]} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <ChartBox chartType="purple-dark" />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>

        </Box>
    );


}

export default AccountsNTransfers;